module.exports = __webpack_public_path__ + "img/introTopImg.d5e59829.jpg";